import { Skeleton } from 'components/ui/skeleton'
import Button from 'components/shared/button'
import useTranslation from 'next-translate/useTranslation'

const SeeAllButton = (props: PropsSeeAllButton) => {
    const { t } = useTranslation('common')
    if (!props.loading)
        return (
            <Button
                className="ml-1 self-end underline whitespace-nowrap"
                variant="link"
                onClick={() => props.onClick()}>
                {t('seeAll')}
            </Button>
        )
    else return <Skeleton className="w-[6vw] h-[20px] self-end mt-1" />
}

export default SeeAllButton
